import { render, staticRenderFns } from "./VideosList.vue?vue&type=template&id=776a0709&scoped=true"
import script from "./VideosList.vue?vue&type=script&lang=js"
export * from "./VideosList.vue?vue&type=script&lang=js"
import style0 from "./VideosList.vue?vue&type=style&index=0&id=776a0709&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "776a0709",
  null
  
)

export default component.exports